module.exports = __webpack_public_path__ + "img/achive.769bfc08.png";